import * as caseConversion from './CASE_CONVERSION_PATTERNS';
import * as templateProcessing from './TEMPLATE_PROCESSING_PATTERNS';
import * as validation from './VALIDATION_PATTERNS';
import * as stringManipulation from './STRING_MANIPULATION_PATTERNS';
import * as githubParsing from './GITHUB_PARSING_PATTERNS';
import * as email from './EMAIL_PATTERNS';
import * as phone from './PHONE_PATTERNS';
import * as color from './COLOR_PATTERNS';
import * as jsonExtraction from './JSON_EXTRACTION_PATTERNS';
import * as url from './URL_PATTERNS';

/**
 * @group Constants
 * @summary <blockquote>Centralized regex patterns organized by category.</blockquote>
 * 
 * All regex patterns used across the codebase are organized here by category.
 * This eliminates magic regex strings and makes patterns discoverable and testable.
 * 
 * @example
 * ```typescript
 * import { REGEX_PATTERNS } from '@shared/utils/regex';
 * 
 * // Use case conversion pattern
 * const kebab = 'UserService'.replace(
 *   REGEX_PATTERNS.caseConversion.PASCAL_TO_KEBAB_UPPERCASE.regex,
 *   '-$1'
 * ).toLowerCase();
 * 
 * // Use validation pattern
 * const isValid = REGEX_PATTERNS.validation.KEBAB_CASE.regex.test('user-service');
 * ```
 */
export const REGEX_PATTERNS = {
  caseConversion: caseConversion.CASE_CONVERSION_PATTERNS,
  templateProcessing: templateProcessing.TEMPLATE_PROCESSING_PATTERNS,
  validation: validation.VALIDATION_PATTERNS,
  stringManipulation: stringManipulation.STRING_MANIPULATION_PATTERNS,
  githubParsing: githubParsing.GITHUB_PARSING_PATTERNS,
  email: email.EMAIL_PATTERNS,
  phone: phone.PHONE_PATTERNS,
  color: color.COLOR_PATTERNS,
  jsonExtraction: jsonExtraction.JSON_EXTRACTION_PATTERNS,
  url: url.URL_PATTERNS,
} as const;
